/**
 * The one place an API date string becomes a Date. Mirrors frontend/src/lib/dates.ts.
 *
 * A calendar date ("2026-10-01": founded date, joined date) names a day and is the
 * same day for every viewer, so it is built from its parts as local midnight. An
 * instant ("2026-09-30T21:00:00.000000Z": createdAt, dueAt) is a moment in time and
 * is shown on the viewer's own clock.
 *
 * `new Date('2026-10-01')` reads a calendar date as UTC midnight, which is the
 * evening of 30 Sep anywhere west of UTC.
 */
const CALENDAR_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

export function parseApiDate(value: string): Date {
  const parts = CALENDAR_DATE.exec(value);
  if (parts) return new Date(Number(parts[1]), Number(parts[2]) - 1, Number(parts[3]));
  return new Date(value);
}
